/**
 * ToolBar.js
 * Werkzeugleiste fuer den Pixel-Editor.
 * Tools: Stift, Fuelleimer, Radierer, Pipette, Linie, Rechteck
 */

import React from 'react';

const TOOLS = [
  { id: 'pencil',   label: 'Stift',      icon: '✏️',  title: 'Stift (einzelnes Pixel malen)' },
  { id: 'eraser',   label: 'Radierer',   icon: '⬜',  title: 'Radierer (auf Transparent setzen)' },
  { id: 'fill',     label: 'Fuelleimer', icon: '🪣',  title: 'Fuelleimer (Flood-Fill)' },
  { id: 'picker',   label: 'Pipette',    icon: '💉',  title: 'Pipette (Farbe aufnehmen)' },
  { id: 'line',     label: 'Linie',      icon: '╱',   title: 'Linie zeichnen' },
  { id: 'rect',     label: 'Rechteck',   icon: '⬜',  title: 'Rechteck zeichnen' },
];

function ToolBar({
  activeTool,
  onToolChange,
  zoom,
  onZoomChange,
  showGrid,
  onToggleGrid,
  rectFilled,
  onToggleRectFilled,
  symmetryMode,
  onSymmetryChange,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  onClear,
  onFill,
}) {
  return (
    <div className="pixel-toolbar">
      {/* Zeichen-Tools */}
      <div className="pixel-toolbar-group">
        {TOOLS.map(tool => (
          <button
            key={tool.id}
            className={`pixel-tool-btn ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => onToolChange(tool.id)}
            title={tool.title}
          >
            <span style={{ fontSize: tool.icon.length === 1 ? 18 : 14 }}>{tool.icon}</span>
            <span className="pixel-tool-label">{tool.label}</span>
          </button>
        ))}
      </div>

      <div className="pixel-toolbar-divider" />

      {/* Rechteck-Option */}
      {activeTool === 'rect' && (
        <>
          <div className="pixel-toolbar-group">
            <label className="pixel-tool-option" title="Gefuelltes Rechteck zeichnen">
              <input
                type="checkbox"
                checked={rectFilled}
                onChange={e => onToggleRectFilled(e.target.checked)}
              />
              <span>Gefuellt</span>
            </label>
          </div>
          <div className="pixel-toolbar-divider" />
        </>
      )}

      {/* Symmetrie */}
      <div className="pixel-toolbar-group">
        <span className="pixel-toolbar-label">Symmetrie:</span>
        {[
          { value: 'none',       label: 'Keine' },
          { value: 'horizontal', label: 'Horizontal' },
          { value: 'vertical',   label: 'Vertikal' },
          { value: 'both',       label: 'Beide' },
        ].map(s => (
          <button
            key={s.value}
            className={`pixel-tool-btn small ${symmetryMode === s.value ? 'active' : ''}`}
            onClick={() => onSymmetryChange(s.value)}
            title={`Symmetrie: ${s.label}`}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="pixel-toolbar-divider" />

      {/* Zoom */}
      <div className="pixel-toolbar-group">
        <span className="pixel-toolbar-label">Zoom: {zoom}x</span>
        <button className="pixel-tool-btn small" onClick={() => onZoomChange(Math.max(2, zoom - 2))} disabled={zoom <= 2}>−</button>
        <button className="pixel-tool-btn small" onClick={() => onZoomChange(Math.min(32, zoom + 2))} disabled={zoom >= 32}>+</button>
        <button className="pixel-tool-btn small" onClick={() => onZoomChange(8)} title="Zoom zuruecksetzen">Reset</button>
      </div>

      <div className="pixel-toolbar-divider" />

      {/* Grid, Undo, Redo, Clear */}
      <div className="pixel-toolbar-group">
        <button
          className={`pixel-tool-btn small ${showGrid ? 'active' : ''}`}
          onClick={onToggleGrid}
          title="Pixel-Gitter ein/ausblenden"
        >
          Grid
        </button>
        <button
          className="pixel-tool-btn small"
          onClick={onUndo}
          disabled={!canUndo}
          title="Rueckgaengig (Strg+Z)"
        >
          ↩ Undo
        </button>
        <button
          className="pixel-tool-btn small"
          onClick={onRedo}
          disabled={!canRedo}
          title="Wiederherstellen (Strg+Y)"
        >
          ↪ Redo
        </button>
      </div>

      <div className="pixel-toolbar-divider" />

      <div className="pixel-toolbar-group">
        <button
          className="pixel-tool-btn small btn-danger"
          onClick={onClear}
          title="Canvas leeren (loescht alle Pixel)"
        >
          Leeren
        </button>
        <button
          className="pixel-tool-btn small"
          onClick={onFill}
          title="Mit aktueller Farbe fuellen"
        >
          Fuellen
        </button>
      </div>
    </div>
  );
}

export default ToolBar;
